import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NavParams, ViewController } from "ionic-angular";

/**
 * Generated class for the UserPopoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "new-wound-site-popover",
  templateUrl: "new-wound-site-popover.html",
})
export class NewWoundSitePopoverPage {
  woundData: any;

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private translate: TranslateService
  ) {
    let val = this.navParams.data.allPointsData.value;
    if (val.length > 0) {
      val = this.navParams.data.allPointsData.value.filter(
        (x) => x.woundStatus !== "inprogress"
      );
      this.woundData = val;
    }
  }

  emitValue(data) {
    this.viewCtrl.dismiss(data);
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/new-wound-site-card/new-wound-site-popover/new-wound-site-popover.ts